import { Blocks, FieldDropdown, FieldLabel, type Block } from 'blockly/core';

import { getBeginnerPinOptions } from '../pins/pin-selector.js';
import { BEGINNER_DISPLAY_BLOCK_STYLE } from './display-helpers.js';
import { OLED_ADDRESS_OPTIONS } from './oled-fields.js';
import { getOledI2cUi } from './oled-i2c-ui.js';

const PIN_DETAILS_INPUT = 'PIN_DETAILS';

function pinDropdown(): FieldDropdown {
  return new FieldDropdown(() => getBeginnerPinOptions('digital'));
}

function appendI2cPinDetails(block: Block): void {
  if (block.getInput(PIN_DETAILS_INPUT)) {
    block.removeInput(PIN_DETAILS_INPUT);
  }

  const input = block.appendDummyInput(PIN_DETAILS_INPUT);
  const ui = getOledI2cUi();

  if (ui.mode === 'fixed') {
    input.appendField(new FieldLabel(ui.label));
    return;
  }

  input
    .appendField('SCL')
    .appendField(pinDropdown(), 'SCL_PIN')
    .appendField('SDA')
    .appendField(pinDropdown(), 'SDA_PIN');
}

let registered = false;

/**
 * Configure OLED — address always; I²C pins shown as labels or ESP32 dropdowns.
 * Does not expose Wire / I²C protocol names beyond SCL/SDA pin labels.
 */
export function registerBeginnerOledConfigureBlock(): void {
  if (registered || Blocks['beginner_oled_configure']) {
    registered = true;
    return;
  }

  Blocks['beginner_oled_configure'] = {
    init(this: Block) {
      this.appendDummyInput('HEADER')
        .appendField('configure OLED address')
        .appendField(new FieldDropdown(OLED_ADDRESS_OPTIONS), 'ADDRESS');
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setStyle(BEGINNER_DISPLAY_BLOCK_STYLE);
      this.setTooltip(
        'Sets up the OLED display. On ESP32 you choose SCL and SDA; other boards show fixed pins.',
      );
      this.setHelpUrl('');
      appendI2cPinDetails(this);
    },
  };

  registered = true;
}
